import InputBase from "./InputBase";

const EmailInput = (props) => <InputBase {...props} type="email" />;

export default EmailInput;
